<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称" prop="goodsName">
                <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" placeholder="请输入商品名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择审核状态" allow-clear>
                  <a-select-option :value="2">待审核</a-select-option>
                  <a-select-option :value="3">审核通过</a-select-option>
                  <a-select-option :value="4">审核失败</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a-button style="margin-left: 8px" type="primary" :disabled="selectedRowKeys.length === 0" @click="handleAudit(3)" v-hasPermi="['goods:platform:audit']">
                  <a-icon type="check" />批量通过
                </a-button>
                <a-button style="margin-left: 8px" :disabled="selectedRowKeys.length === 0" @click="handleAudit(4)" v-hasPermi="['goods:platform:audit']">
                  <a-icon type="close" />批量驳回
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-alert type="info" show-icon style="margin-bottom: 16px">
        <template slot="message">
          审核通过后，若该报价的售价大于0且库存大于0，买家即可在App上选中对应规格直接购买或加入购物车；否则仅可浏览。
        </template>
      </a-alert>
      <!-- 数据展示 -->
      <a-table
        :scroll="{ x: 1500 }"
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="false"
      >
        <template slot="picture" slot-scope="text, record">
          <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" alt="none"/>
        </template>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
        </span>
        <span slot="onlineBuy" slot-scope="text, record">
          <a-tag v-if="record.onlineBuy" color="green">可购买</a-tag>
          <a-tag v-else color="default">仅浏览</a-tag>
        </span>
        <span slot="auditRemark" slot-scope="text, record">
          {{ record.auditRemark || '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-button size="small" type="link" v-if="record.status === 2" @click="handleAudit(3, record)" v-hasPermi="['goods:platform:audit']">
            <a-icon type="check" />通过
          </a-button>
          <a-button size="small" type="link" style="color:#f5222d" v-if="record.status === 2" @click="handleAudit(4, record)" v-hasPermi="['goods:platform:audit']">
            <a-icon type="close" />驳回
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageQuoteAudit, auditPlatformQuote } from '@/api/goods/goods'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'

export default {
  name: 'QuoteAudit',
  components: {
    CustomDictTag
  },
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      selectedRowKeys: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      queryParam: {
        goodsName: undefined,
        status: 2,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 260 },
        { title: '图片', dataIndex: 'picture', width: '80px', scopedSlots: { customRender: 'picture' } },
        { title: '商家', dataIndex: 'merchantName', width: 160 },
        { title: '规格组合', dataIndex: 'skuName', width: 180 },
        { title: '售价', dataIndex: 'price', width: '90px' },
        { title: '库存', dataIndex: 'stock', width: '80px' },
        { title: '运费模板', dataIndex: 'expressName', width: 140 },
        { title: '状态', dataIndex: 'status', width: '100px', scopedSlots: { customRender: 'status' } },
        { title: '是否可购买', dataIndex: 'onlineBuy', width: '110px', scopedSlots: { customRender: 'onlineBuy' } },
        { title: '审核备注', dataIndex: 'auditRemark', width: '140px', scopedSlots: { customRender: 'auditRemark' } },
        { title: '操作', dataIndex: 'operation', width: 160, scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      pageQuoteAudit(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = response.data.total
        this.selectedRowKeys = []
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        goodsName: undefined,
        status: 2,
        pageNum: 1,
        pageSize: this.queryParam.pageSize
      }
      this.getList()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleAudit (status, record) {
      const that = this
      const idList = record ? [record.id] : this.selectedRowKeys
      const actionName = status === 3 ? '通过' : '驳回'
      this.$confirm({
        title: '报价审核',
        content: `确认${actionName}选中的 ${idList.length} 条商家报价吗？`,
        onOk () {
          return auditPlatformQuote({ idList: idList, status: status }).then(() => {
            that.$message.success(`${actionName}成功`, 3)
            that.getList()
          })
        }
      })
    }
  }
}
</script>
